import { createContext, useCallback, useContext, useMemo, useState } from "react";

const InstaPassAIChatContext = createContext(null);

export function InstaPassAIChatProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [fullscreen, setFullscreen] = useState(false);

  const openChat = useCallback(() => setOpen(true), []);

  const closeChat = useCallback(() => {
    setOpen(false);
    setFullscreen(false);
  }, []);

  const openFullscreen = useCallback(() => {
    setOpen(true);
    setFullscreen(true);
  }, []);

  const closeFullscreen = useCallback(() => {
    setFullscreen(false);
  }, []);

  const value = useMemo(
    () => ({
      open,
      setOpen,
      openChat,
      closeChat,
      fullscreen,
      setFullscreen,
      openFullscreen,
      closeFullscreen,
    }),
    [open, openChat, closeChat, fullscreen, openFullscreen, closeFullscreen]
  );

  return (
    <InstaPassAIChatContext.Provider value={value}>{children}</InstaPassAIChatContext.Provider>
  );
}

export function useInstaPassAIChat() {
  return useContext(InstaPassAIChatContext);
}
